// React-Screen CTransactionShowMode (Bar- und Gutschein-Zahlung) - Strangler
// Phase 5, Klasse B. Runbook: tools/REACT-STRANGLER.md.
// Ersetzt die ESM-Huelle transactionshowmode.js (aus
// lib/scripts/pos/components/CMP_CTransactionShowMode.js).
// Legacy-DOM-Fixtures: tests/react-fixtures/CTransactionShowMode.html (wie
// draw() ihn baut - PRELOAD aus CSessionHandler.addSession, steht in JEDER
// eingeloggten Baseline) und der gezeigte Zustand in den Galerie-Eintraegen
// 12-overlay-zahlung-bar / 13-overlay-zahlung-gutschein.
//
// Der Screen fasst GELD an. Alle Rechenwege sind zeichengenau uebernommen;
// geaendert ist nur, WO die Sichtbarkeit der beiden XML-Knoepfe steht:
// Legacy schrieb sie nach components.okButton.properties.styles + reStyle(),
// hier laeuft sie ueber bridge.state (React ist Eigentuemer dieser beiden
// Elemente). Die dynamisch erzeugten okButtons/noteButtons bleiben ECHTE
// Legacy-Komponenten und behalten ihren Code unveraendert (siehe
// spec.mountLegacy-Regel im Kopf von bridge.js) - sie haengen hinter den
// React-Knoten, genau wie im Legacy.
//
// reVALUE-FALLE: titleText/contentText/priceText werden per reValue()
// gewechselt, das class-Attribut bleibt deshalb auf dem BAUZEIT-Wert des
// Preloads stehen ("CCaption titletext Mode", "CCaption contenttext  ").
import { defineReactScreen } from '../bridge.js';
import { CPushButton } from '../../components/pushbutton.js';
import { KnopfAusHandle } from '../widgets.jsx';

// classValue = eingefrorener Bauzeit-Wert (Klasse), value = Zustand (Text).
function Caption({ bridge, path, addclass, classValue, value, style }) {
  const cls = 'CCaption' + (addclass ? ' ' + addclass : '') + ' ' +
    (classValue === undefined ? value : classValue);
  return <p {...bridge.el(path, 'CCaption')} className={cls} style={style}
            dangerouslySetInnerHTML={{ __html: value }} />;
}

// XML-Defaults aus LYT_bonOverlay.xml (= Anfangszustand UND Klassen-Schwanz)
const XML_TITLE = 'Mode';
const XML_EMPTY = ' ';

function TransactionShowModeScreen({ bridge }) {
  // Legacy: beide Knoepfe rufen this.ok, unterschieden ueber Parameter 1.
  const okButton = bridge.widget('7', 'CPushButton', {
    events: { onMousedown: () => bridge.ok(null, [bridge.id, '']), onMouseout: true, onMouseup: true },
    attributes: { onMousedown_parameter_0: bridge.id, onMousedown_parameter_1: '' },
    proto: CPushButton.prototype,
  });
  const backButton = bridge.widget('8', 'CPushButton', {
    events: { onMousedown: () => bridge.ok(null, [bridge.id, 'cancel']), onMouseout: true, onMouseup: true },
    attributes: { onMousedown_parameter_0: bridge.id, onMousedown_parameter_1: 'cancel' },
    proto: CPushButton.prototype,
  });

  // Legacy setzt die Sichtbarkeit dieser beiden erst zur Laufzeit; vorher
  // steht kein style-Attribut am Element - deshalb undefined statt "".
  const vis = (v) => (v ? { visibility: v } : undefined);

  return (
    <>
      {/* wholeOverlay */}
      <div {...bridge.el('0', 'CFrame')} className="CFrame wholeoverlay" style={{ position: 'absolute' }}></div>
      {/* overlay */}
      <div {...bridge.el('1', 'CFrame')} className="CFrame overlay" style={{ position: 'absolute' }}></div>
      {/* titleBack */}
      <div {...bridge.el('2', 'CFrame')} className="CFrame titleback" style={{ position: 'absolute' }}></div>
      {/* titleText */}
      <Caption bridge={bridge} path="3" addclass="titletext" classValue={XML_TITLE}
               value={bridge.state.title} />
      {/* contentText */}
      <Caption bridge={bridge} path="4" addclass="contenttext" classValue={XML_EMPTY}
               value={bridge.state.content} style={{ fontSize: '3.0vh' }} />
      {/* priceText */}
      <Caption bridge={bridge} path="5" addclass="pricetext" classValue={XML_EMPTY}
               value={bridge.state.price}
               style={{ fontSize: '3.0vh', textAlign: 'right', top: '13%' }} />
      {/* unitsText */}
      <Caption bridge={bridge} path="6" addclass="unitstext" value=" " />
      {/* okButton */}
      <div {...okButton} className="CPushButton okbutton" style={vis(bridge.state.okVis)}>
        <Caption bridge={bridge} path="7:0" addclass="" value=" " />
      </div>
      {/* backButton */}
      <div {...backButton} className="CPushButton backbutton" style={vis(bridge.state.backVis)}>
        <p {...bridge.el('8:0', 'CCaption')} className="CCaption undefined"></p>
      </div>
      {/* OK-Tasten (9..11) und Scheintasten (12..19): das DOM baut React,
          die WERTE bleiben in den Handles, die makeOkButtons()/
          makeNoteButtons() unveraendert befuellen. Welche Taste ein Element
          bekommt, steht im Zustand - im Legacy entschied das ein spaeteres
          draw(): okButtons[1] wird nie gezeichnet, noteButtons[0] bricht mit
          continue ab. Handles gibt es fuer ALLE, sonst verschoebe sich die
          Kindfolge und die Legacy-Methoden schrieben ins Leere. */}
      {(bridge.state.okKnoepfe || []).map((gez, i) =>
        gez ? <KnopfAusHandle key={'ok' + i} bridge={bridge} pfad={String(9 + i)} /> : null)}
      {(bridge.state.notizKnoepfe || []).map((gez, i) =>
        gez ? <KnopfAusHandle key={'note' + i} bridge={bridge} pfad={String(12 + i)} /> : null)}
    </>
  );
}

export const CTransactionShowMode = defineReactScreen({
  className: 'CTransactionShowMode',
  addclass: 'CTransactionShowMode CashWindow',
  htmlType: 'div',
  Screen: TransactionShowModeScreen,
  initialState: { title: XML_TITLE, content: XML_EMPTY, price: XML_EMPTY, okVis: null, backVis: null,
    okKnoepfe: [], notizKnoepfe: [] },
  prepare(bridge) {
    // Felder des Legacy-Konstruktors.
    bridge.paymentType = null;
    bridge.payAmount = 0;
    bridge.returnAmount = 0;
    bridge.openSum = null;
    bridge.openMoney = null;
    bridge.doPrint = false;
    bridge.isNegative = false;

    bridge.Main = POS.sessions.getSessionComponent();
  },
  methods: {
    // Aufrufer: CPaymentProcessor (setzt vorher paymentType/openSum/...).
    show(bridge) {
      var el = document.getElementById(bridge.id);
      el.style.visibility = 'visible';

      var message;
      switch (bridge.paymentType) {
        case 'BAR':
          POS.Cashbox.canBeOpen = true;
          POS.Cashbox.countdown = 75;
          POS.Cashbox.callbackFunction = bridge.drawerClosed;
          POS.Cashbox.callbackParameter = bridge;
          POS.Cashbox.showHourglass = false;
          POS.Cashbox.openDrawer();
          var title = bridge.t('LABELS', 'CASH_PAYMENT');
          if (bridge.isNegative) {
            message = '<br>';
            message += "<span style='color:#FF0000'>Retour:</span><br>";
          } else {
            message = 'Gegeben:<br>';
            message += "<span style='color:#FF0000'>Retour:</span><br>";
            message += 'Offen:';
          }
          break;
        case 'VCR':
          title = bridge.t('LABELS', 'VOUCHER_PAYMENT');
          message = 'Gegeben:<br>';
          message += 'Offen:';
          break;
      }

      bridge.update({ title: title, content: message, price: bridge.getAmounts() });

      bridge.updateDisplay();

      bridge.Main.components.info.input.properties.changeValueCallback.cls = bridge;
      bridge.Main.components.info.input.properties.changeValueCallback.fnc = bridge.onValueChanged;

      bridge.Main.components.bonfnc.setEnabled(false);
      bridge.Main.components.payment.setEnabled(false);
      bridge.Main.components.payment2.setEnabled(false);
      bridge.Main.components.bonedit.setEnabled(false);
      bridge.Main.components.prodSelect.setEnabled(false);
      bridge.Main.components.leftPad.setEnabled(false);

      bridge.Main.confirmInput();

      bridge.resetButtonsVisibility();

    },
    updateDisplay(bridge) {
      Display.addLine();
      if (bridge.paymentType == 'BAR') {
        Display.addElement(bridge.t('LABELS', 'RETURN') + ':', 0, 0, 0, 19);
        Display.addElement(float2StringD2(bridge.returnAmount) + ' &euro;', 19, 1, 0, 19);
      } else
        Display.addElement('', 0, 0, 0, 19);

      Display.addLine();
      Display.addElement(bridge.t('LABELS', 'OPEN') + ':', 0, 0, 0, 19);
      Display.addElement(float2StringD2(bridge.openMoney) + ' &euro;', 19, 1, 0, 19);

      Display.out();
    },
    // Kassenladen-Rueckmeldung (POS.Cashbox.callbackFunction).
    drawerClosed(bridge) {
      POS.Cashbox.callbackFunction = bridge.drawerClosed;
      POS.Cashbox.callbackParameter = bridge;

      if (bridge.okButtons[2].properties.styles.visibility == 'hidden' && bridge.paymentType == 'BAR') {
        bridge.okButtons[2].properties.styles.visibility = 'visible';
        bridge.okButtons[2].reStyle();
      }

      POS.hourGlass.hide();
    },
    openDrawer(bridge) {
      POS.Cashbox.callbackFunction = bridge.drawerClosed;
      POS.Cashbox.callbackParameter = bridge;
      POS.Cashbox.openDrawer();

      POS.timeout.register('hideCashboxButton', bridge.hideCashboxButton, bridge, 2, 1);
    },
    hideCashboxButton(bridge) {
      bridge.okButtons[2].properties.styles.visibility = 'hidden';
      bridge.okButtons[2].reStyle();
    },
    // Schein-Knopf: Betrag aufaddieren.
    sumNoteAmount(bridge, component, parameters) {
      var noteAmount = parameters[1];

      bridge.Main.BonManager.switchSumInfo(false);

      if (noteAmount == 'X') {
        bridge.payAmount = 0;
        noteAmount = bridge.openSum;
      } else
        bridge.payAmount = remEuropeanComma(bridge.Main.components.info.input.properties.attributes.value);

      if (!bridge.payAmount)
        bridge.payAmount = '0';

      if (bridge.payAmount[bridge.payAmount.length - 1] == '.')
        bridge.payAmount = bridge.payAmount.replace('.', '');

      var totalPayAmount = parseFloat(bridge.payAmount) + parseFloat(noteAmount);
      totalPayAmount = totalPayAmount.toString().replace('.', ',');

      bridge.Main.components.info.input.properties.attributes.value = totalPayAmount;
      bridge.Main.components.info.input.reAttribute();

      bridge.onValueChanged(bridge);
    },
    // changeValueCallback des Universalfeldes.
    onValueChanged(bridge) {
      bridge.Main.BonManager.switchSumInfo(false);

      if (bridge.isNegative)
        return;

      bridge.payAmount = remEuropeanComma(bridge.Main.components.info.input.properties.attributes.value);

      if (bridge.payAmount[bridge.payAmount.length - 1] == '.')
        bridge.payAmount = bridge.payAmount.replace('.', '');

      if (bridge.paymentType == 'VCR')
        bridge.payAmount *= 1;

      if (bridge.payAmount >= bridge.openSum) {
        if (bridge.doPrint == false) {
          bridge.doPrint = true;

          bridge.update({ okVis: 'hidden' });

          for (var i = 0; i < bridge.okButtons.length - 1; i++) {
            if (i == 1)
              continue;
            if (i == 1 && (bridge.Main.BonManager.isReclamationBon || bridge.Main.BonManager.isPaydown || bridge.Main.BonManager.wasPaydown))
              continue;
            bridge.okButtons[i].properties.styles.visibility = 'visible';
            bridge.okButtons[i].reStyle();
          }
        }
        bridge.returnAmount = bridge.payAmount - bridge.openSum;
        bridge.openMoney = 0;
      } else {
        if (bridge.doPrint == true) {
          bridge.doPrint = false;

          bridge.update({ okVis: 'visible' });

          for (var i = 0; i < bridge.okButtons.length - 1; i++) {
            if (i == 1)
              continue;
            bridge.okButtons[i].properties.styles.visibility = 'hidden';
            bridge.okButtons[i].reStyle();
          }
        }
        bridge.returnAmount = 0;
        bridge.openMoney = bridge.openSum - bridge.payAmount;
      }

      bridge.update({ price: bridge.getAmounts() });

      bridge.updateDisplay();
    },
    getAmounts(bridge) {
      var message;
      switch (bridge.paymentType) {
        case 'BAR':
          if (bridge.isNegative) {
            message = '<br>' +
              "<span style='color:#FF0000'>" +
              float2StringD2(bridge.openMoney) + ' &euro;</span><br>';
          } else {
            message = float2StringD2(bridge.payAmount) + ' &euro;<br>' +
              "<span style='color:#FF0000'>" +
              float2StringD2(bridge.returnAmount) + ' &euro;</span><br>' +
              float2StringD2(bridge.openMoney) + ' &euro;';
          }
          break;
        case 'VCR':
          message = float2StringD2(bridge.payAmount) + ' &euro;<br>' +
            float2StringD2(bridge.openMoney) + ' &euro;';
          break;
      }

      return message;
    },
    // Unveraendert uebernommen - ruft nackte Globals und wuerfe deshalb;
    // niemand ruft sie auf (Ist-Verhalten, siehe Hauptrunbook).
    calcOpenMoney(bridge) {
      bridge.openMoney = fix2Decimals(openSum - payAmount + returnAmount);
    },
    // Aufrufer: CSessionHandler.addSession, direkt nach draw().
    makeNoteButtons(bridge) {
      if (bridge.paymentType == 'VCR')
        return;

      bridge.noteButtons = new Array();
      // Scheintasten liegen auf 12..19 (die OK-Tasten davor auf 9..11).
      // sessionhandler.js ruft makeOkButtons() ZUERST - daher diese Reihung.
      var gezeichnet = [false, false, false, false, false, false, false, false];
      var values = new Array('0', '5', '10', '20', 'X', '50', '100', '200');
      var images = Array(
        '',
        'lib/img/currency/EUR/5.png',
        'lib/img/currency/EUR/10.png',
        'lib/img/currency/EUR/20.png',
        'lib/img/currency/EUR/sum.png',
        'lib/img/currency/EUR/50.png',
        'lib/img/currency/EUR/100.png',
        'lib/img/currency/EUR/200.png');

      var left = 32;

      for (var i = 0; i < 8; i++) {
        bridge.noteButtons[i] = bridge.widgetHandle(String(12 + i));

        if (i == 0) {
          bridge.noteButtons[i].properties.styles.visibility = 'hidden';
          continue;
        }

        bridge.noteButtons[i].properties.events.onMousedown = (component, parameters) =>
          bridge.sumNoteAmount(component, parameters);
        bridge.noteButtons[i].properties.attributes.onMousedown_parameter_0 = bridge.id;
        bridge.noteButtons[i].properties.attributes.onMousedown_parameter_1 = values[i];
        bridge.noteButtons[i].properties.styles.position = 'absolute';
        bridge.noteButtons[i].properties.styles.zIndex = '0';
        if (i < 4)
          bridge.noteButtons[i].properties.styles.top = '40%';
        else {
          bridge.noteButtons[i].properties.styles.top = '58%';
          if (i == 4)
            left = 10;
        }
        bridge.noteButtons[i].properties.styles.width = '7vw';
        bridge.noteButtons[i].properties.styles.height = '6vh';
        bridge.noteButtons[i].properties.styles.left = left + '%';
        bridge.noteButtons[i].properties.styles.backgroundColor = '#AAAAFF';
        bridge.noteButtons[i].properties.styles.borderColor = '#8888FF';
        bridge.noteButtons[i].properties.styles.backgroundRepeat = 'no-repeat';
        bridge.noteButtons[i].properties.styles.backgroundPosition = 'center';
        bridge.noteButtons[i].properties.styles.backgroundSize = 'cover';
        bridge.noteButtons[i].properties.styles.backgroundImage = 'url(' + images[i] + ')';
        bridge.noteButtons[i].properties.styles.visibility = 'hidden';
        gezeichnet[i] = true;   // statt draw() - React zeichnet
        left += 22;
      }
      bridge.update({ notizKnoepfe: gezeichnet });
    },
    makeOkButtons(bridge) {
      bridge.okButtons = new Array();
      // OK-Tasten liegen auf 9..11. Index 1 wird NIE gezeichnet (kein draw()
      // im Legacy) - Handle ja, Element nein, sonst verschoebe sich 12..19.
      var okGezeichnet = [false, false, false];

      for (var i = 0; i < 3; i++) {
        bridge.okButtons[i] = bridge.widgetHandle(String(9 + i));
        bridge.okButtons[i].properties.attributes.onMousedown_parameter_0 = bridge.id;
        bridge.okButtons[i].properties.styles.visibility = 'hidden';
        bridge.okButtons[i].properties.styles.position = 'absolute';
        bridge.okButtons[i].properties.styles.top = '80%';
        bridge.okButtons[i].properties.styles.width = '6vw';
        bridge.okButtons[i].properties.styles.height = '6vh';
        bridge.okButtons[i].properties.styles.backgroundColor = '#BBF3BB';
        bridge.okButtons[i].properties.styles.borderColor = '#77CC77';
      }

      bridge.okButtons[0].properties.styles.left = '10%';
      bridge.okButtons[0].properties.caption.value = bridge.t('BUTTONS', 'PRINT_BON');
      bridge.okButtons[0].properties.attributes.onMousedown_parameter_1 = 'bill';
      bridge.okButtons[0].properties.events.onMousedown = (component, parameters) =>
        bridge.ok(component, parameters);
      okGezeichnet[0] = true;

      bridge.okButtons[2].properties.styles.top = '40%';
      bridge.okButtons[2].properties.styles.left = '10%';
      bridge.okButtons[2].properties.styles.backgroundColor = '#FFC57A';
      bridge.okButtons[2].properties.styles.borderColor = '#FF8204';
      bridge.okButtons[2].properties.caption.value = bridge.t('BUTTONS', 'OPEN_DRAWER');
      bridge.okButtons[2].properties.events.onMousedown = (component, parameters) =>
        bridge.openDrawer(component, parameters);
      okGezeichnet[2] = true;
      bridge.update({ okKnoepfe: okGezeichnet });
    },
    sendDisplayPaid(bridge, Retour) {
      Display.addLine();
      Display.addElement(bridge.t('DISPLAY', 'PAID'), 0, 0, 0, 19);
      Display.addLine();
      if (Retour) {
        Display.addElement('Retour: ' + Retour + '€', 0, 0, 0, 19);
      } else {
        Display.addElement('', 0, 0, 0, 19);
      }
      Display.out();
    },
    resetDisplay(bridge) {
      Display.addLine();
      Display.addElement('', 0, 0, 0, 19);
      Display.addLine();
      Display.addElement('', 0, 0, 0, 19);
      Display.out();
    },
    doPayVoucher(bridge, me, result) {
      if (result != 'YES') {
        bridge.doCancel();
        return;
      }

      bridge.Main.BonManager.payCallback(bridge.Main.BonManager, null, bridge.payAmount,
        0, bridge.openMoney);

      bridge.sendDisplayPaid();

      bridge.doCancel();
    },
    // Der eigentliche Zahlungsabschluss. parameters[1]: "", "bill", "cancel".
    ok(bridge, component, parameters) {
      var el = document.getElementById(bridge.id);
      el.style.visibility = 'hidden';

      switch (parameters[1]) {
        case 'cancel':
          log.add(4, 'Info', 'Pressed CANCEL Button', '');
          break;
        case 'bill':
          log.add(4, 'Info', 'Pressed OK Button to print a bill', '');
          break;
        default:
          log.add(4, 'Info', 'Pressed OK Button (still open sum)', '');
          break;
      }

      bridge.redrawButtons(bridge);

      if (bridge.paymentType == 'BAR') {
        POS.Cashbox.callbackFunction = bridge.end;
        POS.Cashbox.callbackParameter = bridge;
        POS.Cashbox.canBeOpen = false;
      }

      if (!bridge.isNegative &&
        (bridge.payAmount == 0 && !parameters[1] || bridge.payAmount == 0 && !bridge.Main.BonManager.isReclamationBon))
        parameters[1] = 'cancel';

      bridge.Main.components.info.input.properties.changeValueCallback.cls = bridge.Main;
      bridge.Main.components.info.input.properties.changeValueCallback.fnc = bridge.Main.enterInfo;

      if (parameters[1] != 'cancel') {
        bridge.Main.BonManager.printMode = parameters[1];

        switch (bridge.paymentType) {
          case 'BAR':
            if (bridge.isNegative)
              bridge.Main.BonManager.payCallback(bridge.Main.BonManager, null, 0,
                Math.abs(bridge.openMoney), 0);
            else
              bridge.Main.BonManager.payCallback(bridge.Main.BonManager, null, bridge.payAmount,
                bridge.returnAmount, bridge.openMoney);
            bridge.sendDisplayPaid(float2StringD2(bridge.returnAmount));
            break;
          case 'VCR':
            if (bridge.returnAmount > 0) {
              var text = bridge.t('MESSAGES', 'CONF_PAY_VOUCHER');
              POS.message.show(text, 'question', 'YESNO', bridge, bridge.doPayVoucher);
            } else
              bridge.doPayVoucher(bridge, 'YES');
            return;
        }
      } else
        bridge.resetDisplay();

      if (!POS.Cashbox.isDrawerOpen()) {
        log.add(4, 'Info', 'Cashbox already closed - leaving cash payment mode', '');
        bridge.doCancel();
        return;
      } else {
        log.add(4, 'Info', 'Cashbox open - waiting to be closed', '');
        bridge.update({
          content: bridge.state.content + "<div style='margin-top:22px'>" +
            bridge.t('LABELS', 'CLOSE_CASHBOX'),
        });
      }
    },
    // Ruft niemand auf - unveraendert erhalten.
    enableButtons(bridge) {
      bridge.children[7].setEnabled(true);
      bridge.children[8].setEnabled(true);
      bridge.okButtons[0].setEnabled(true);
      bridge.okButtons[2].setEnabled(true);
    },
    resetButtonsVisibility(bridge) {
      if (bridge.isNegative) {
        bridge.update({ okVis: 'hidden', backVis: 'visible' });
        bridge.okButtons[0].properties.styles.visibility = 'visible';
        bridge.okButtons[0].reStyle();
        return;
      }

      bridge.update({ okVis: 'visible', backVis: 'visible' });
      bridge.okButtons[0].properties.styles.visibility = 'hidden';
      bridge.okButtons[0].reStyle();
      bridge.okButtons[2].properties.styles.visibility = 'hidden';
      bridge.okButtons[2].reStyle();
      if (bridge.paymentType == 'BAR') {
        for (var i = 1; i < bridge.noteButtons.length; i++) {
          bridge.noteButtons[i].setEnabled(true);
          bridge.noteButtons[i].properties.styles.visibility = 'visible';
          bridge.noteButtons[i].reStyle();
        }
      }
    },
    redrawButtons(bridge) {
      bridge.okButtons[0].properties.styles.visibility = 'hidden';
      bridge.okButtons[0].reStyle();
      bridge.okButtons[2].properties.styles.visibility = 'hidden';
      bridge.okButtons[2].reStyle();

      bridge.update({ okVis: 'hidden', backVis: 'hidden' });

      if (typeof bridge.noteButtons != 'undefined') {
        for (var i = 1; i < bridge.noteButtons.length; i++) {
          bridge.noteButtons[i].properties.styles.visibility = 'hidden';
          bridge.noteButtons[i].reStyle();
        }
      }
    },
    end(bridge) {
      log.add(4, 'Info', 'Cashbox closed - leaving cash payment mode', '');
      bridge.doCancel();
    },
    cancel(bridge) {
      bridge.doCancel();
    },
    doCancel(bridge) {
      bridge.redrawButtons(bridge);
      bridge.isNegative = false;

      POS.Cashbox.canBeOpen = false;
      POS.Cashbox.showHourglass = true;
      POS.Cashbox.countdown = POS.Cashbox.defaultCountdown;
      POS.Cashbox.callbackFunction = null;
      POS.Cashbox.callbackParameter = null;

      bridge.Main.components.bonfnc.setEnabled(true);
      bridge.Main.components.payment.setEnabled(true);
      bridge.Main.components.payment2.setEnabled(true);
      bridge.Main.components.bonedit.setEnabled(true);
      bridge.Main.components.prodSelect.setEnabled(true);
      bridge.Main.components.leftPad.setEnabled(true);

      bridge.Main.vacuumInfoValue(bridge.Main);
      bridge.Main.components.info.input.properties.changeValueCallback.cls = bridge.Main;
      bridge.Main.components.info.input.properties.changeValueCallback.fnc = bridge.Main.enterInfo;


      bridge.properties.styles.visibility = 'hidden';
      bridge.reStyle();

      bridge.doPrint = false;
      bridge.paymentType = null;

      log.add(4, 'Info', 'End cash & voucher payment', '');
    },
  },
});
